import React, { useRef, useState, useEffect } from 'react';
import SbEditable from 'storyblok-react';
import { AnimatePresence, motion } from 'framer-motion';

import TwoColumns from '~/components/TwoColumns';
import TextCard from '~/components/Dynamic/TextCard';

function VisualContentSlider({ blok }) {
  const slides = blok.slide;
  /* eslint-disable */
  if (!slides.length) return null;

  const progressRef = useRef(null);
  const [progressLeft, setProgressWidth] = useState(0);

  const [active, setActive] = useState(0);

  useEffect(() => {
    const percentage = 100 / slides.length;

    setProgressWidth(percentage * (active + 1) - percentage);
  }, [active]);

  return (
    <SbEditable content={blok} key={blok._uid}>
      <TwoColumns
        className="container my-20 md:my-28"
        reverse
        image={
          <div className={`overflow-hidden h-full w-full`}>
            {slides[active]?.icon?.filename?.length > 0 && (
              <AnimatePresence exitBeforeEnter>
                <div className="w-full aspect-w-16 aspect-h-15">
                  <div>
                    <motion.img
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                      transition={{ duration: 0.3 }}
                      src={slides[active].icon.filename}
                      className="object-cover w-full h-full"
                    />
                  </div>
                </div>
              </AnimatePresence>
            )}
          </div>
        }
        text={
          <div className="flex flex-col max-w-md">
            {blok.textCard?.length > 0 && (
              <div className="mb-2 md:mb-4">
                <TextCard blok={blok.textCard[0]} />
              </div>
            )}

            <div className="grid grid-cols-3 gap-y-4 ">
              {slides.map((slide, i) => (
                <span
                  key={`image-data${i}`}
                  className={`col-span-1 flex last:border-r-0 py-0  w-auto text-16px lg:text-17px hover:opacity-50 transition-opacity duration-200 cursor-pointer select-none ${
                    active === i ? 'text-black font-bold' : 'text-grey '
                  }`}
                  onClick={() => setActive(i)}
                >
                  {slide.subHeading}
                </span>
              ))}
            </div>
            <div className="overflow-hidden">
              <AnimatePresence exitBeforeEnter>
                <motion.div
                  key={slides[active].heading}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.4 }}
                  className={`overflow-hidden mt-4 mb-10 md:mt-10 md:mb-16`}
                >
                  <TextCard
                    className={`max-w-25`}
                    blok={{
                      ...slides[active],
                      headingClass: '!text-28px md:!text-32px',
                      subHeadingClass: 'text-sh opacity-40 hidden md:block',
                      buttonClass: 'mt-0 md:mt-10',
                      icon: '',
                    }}
                  />
                </motion.div>
              </AnimatePresence>
            </div>
            <div className="flex">
              <div ref={progressRef} className="relative flex-1 w-full h-0.5 bg-light-grey">
                <motion.div
                  className="absolute inset-0 h-0.5 bg-blue"
                  animate={{ width: 100 / slides.length + '%', left: progressLeft + '%', bottom: '-2px' }}
                />
              </div>
            </div>
          </div>
        }
      />
    </SbEditable>
  );
}

export default VisualContentSlider;
